import { GetCurrentYear } from '@ukpostbox/helpers';
import React from 'react';

function UserPageFooter() {
	return (
		<div className='faded text-center mt-xxxl pb-md'>
			<small>© Copyright 2008-{GetCurrentYear()} UK Postbox - All Rights Reserved</small>
		</div>
	);
}

export default UserPageFooter;
